/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (key = 'zone')
  {
    this.key = key;
  }


  onSelect (zone, entityHex, { dispatch })
  {
    dispatch.replaceArgs({ [this.key]: zone ? zone.getEntityHex().toString() : null });
  }


  isSelected (zoneData, { navigation, data })
  {
    return navigation.getArg(this.key) === zoneData.getEntityHex().toString() && data.getSelectableZone(zoneData.getDisplayHex()) !== null;
  }


};
